var _defs, _g, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboarding2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 307.293,
    height: 186.951,
    viewBox: "0 0 307.293 186.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M153.979,142.508,166.62,132.3l10.658-.084-6.13,10.856Z",
    transform: "translate(-153.979 -132.218)",
    fill: "#fef4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M206.007,143.468l3.606-11.384,14.752-.05L222.9,143.779Z",
    transform: "translate(-206.007 -132.033)",
    fill: "#fef4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    d: "M257.728,143.974,257.19,132.1l16.023-.055,1.495,11.926Z",
    transform: "translate(-257.19 -132.048)",
    fill: "#fef4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    d: "M307.625,143.661l-4.119-11.952,14.375-.06,7.084,11.7Z",
    transform: "translate(-303.507 -131.649)",
    fill: "#fef4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-5",
    "data-name": "SVGID",
    d: "M358.359,142.807l-6.837-11.318,12.494-.1,11.506,10.846Z",
    transform: "translate(-351.521 -131.393)",
    fill: "#fef4d9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_33",
    x: 10.354,
    y: 0.9,
    width: 30.576,
    height: 31.617,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34",
    x: 15.21,
    y: 0.818,
    width: 31.483,
    height: 31.582,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35",
    x: 20.318,
    y: 0.729,
    width: 31.483,
    height: 31.595,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_36",
    x: 26.229,
    y: 0.687,
    width: 30.127,
    height: 31.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_37",
    x: 30.685,
    y: 0,
    width: 31.317,
    height: 32.161,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383377",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_26289",
    x: 189.638,
    y: 35.156,
    width: 117.655,
    height: 151.796,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4b4495",
    floodOpacity: 0.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-_2",
    "data-name": "Onboarding- 2",
    transform: "translate(117.234 6.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14819",
    "data-name": "Group 14819",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14738",
    "data-name": "Group 14738",
    transform: "translate(-117.234 -4.003)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14814",
    "data-name": "Group 14814",
    transform: "translate(17.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27672",
    "data-name": "Path 27672",
    d: "M301.841,91.11l1.8,17.567h.675L302.668,91.11Z",
    transform: "translate(-298.538 -71.112)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27673",
    "data-name": "Path 27673",
    d: "M364.476,91.123l-2.194,17.628-.451.014,1.934-17.654Z",
    transform: "translate(-331.541 -71.112)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27674",
    "data-name": "Path 27674",
    d: "M332.139,109.625l.069,8.764h.6l.129-8.764Z",
    transform: "translate(-315.206 -80.736)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27668",
    "data-name": "Path 27668",
    d: "M295.054,85.817l1.85,1.343,9.623.325.521,6.752,1.552,1.57,7.348.109,1.626-1.678.64-6.631,9.881-.446,2.193-1.343-22.871-2.984Z",
    transform: "translate(-294.805 -66.559)",
    fill: "#191350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27669",
    "data-name": "Path 27669",
    d: "M329.983,56.762H318.964l.931-9.65a64.493,64.493,0,0,0-15.252,0l.745,9.65H294.5l.249,9.154h11.345l.65,8.42h10.525l.812-8.42h11.9Z",
    transform: "translate(-294.5 -46.657)",
    fill: "#48d1cc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27157",
    "data-name": "Path 27157",
    d: "M297.564,131.417l-2.374,74.455-.838,26.2c-.1,2.811-1.877,5.031-4.031,5.031H151.079c-2.179,0-3.961-2.253-4.037-5.089L144.586,131.35c-.082-2.976,1.751-5.458,4.031-5.458H293.534C295.839,125.892,297.672,128.407,297.564,131.417Z",
    transform: "translate(-126.663 -87.968)",
    fill: "#191350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27158",
    "data-name": "Path 27158",
    d: "M153.64,133.032l1.215,93.012,136.636-.179,2.5-93.211Z",
    transform: "translate(-128.789 -90.256)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27159",
    "data-name": "Path 27159",
    d: "M148.586,257.32v-2.309L320.417,253.9l-.143,3.48s.046,4.661-4.7,5.03H153.292A5.077,5.077,0,0,1,148.586,257.32Z",
    transform: "translate(-140.501 -113.276)",
    fill: "#dbdaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14721",
    "data-name": "Group 14721",
    transform: "translate(102.213 89.773)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17356",
    "data-name": "Rectangle 17356",
    width: 26.005,
    height: 1.819,
    transform: "translate(0 6.855)",
    fill: "#4b4495"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17357",
    "data-name": "Rectangle 17357",
    width: 39.238,
    height: 1.819,
    transform: "translate(0 10.198)",
    fill: "#4b4495"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17358",
    "data-name": "Rectangle 17358",
    width: 26.005,
    height: 1.819,
    transform: "translate(0 3.645)",
    fill: "#4b4495"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17359",
    "data-name": "Rectangle 17359",
    width: 15.599,
    height: 1.819,
    fill: "#4b4495"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17363",
    "data-name": "Rectangle 17363",
    width: 3.33,
    height: 1.819,
    transform: "translate(27.666 6.746)",
    fill: "#4b4495"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17368",
    "data-name": "Rectangle 17368",
    width: 15.599,
    height: 1.819,
    transform: "translate(17.577)",
    fill: "#4b4495"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27173",
    "data-name": "Path 27173",
    d: "M300.644,224.638V232.1h32.007l.441-7.465Z",
    transform: "translate(-198.431 -116.751)",
    fill: "#48d1cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14802",
    "data-name": "Group 14802",
    transform: "translate(0 36.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27691",
    "data-name": "Path 27691",
    d: "M146.937,169.034l146.969,2.118.95-23.118-148.763,7.553Z",
    transform: "translate(-128.172 -140.551)",
    fill: "#4b4495",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14737",
    "data-name": "Group 14737",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27179",
    "data-name": "Path 27179",
    d: "M138.375,162.579h0c-4.653,0-8.787-2.766-9.233-6.178l-1.264-9.669h17.24l1.027,9.669C146.507,159.813,143.028,162.579,138.375,162.579Z",
    transform: "translate(-127.878 -136.558)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27180",
    "data-name": "Path 27180",
    d: "M163.981,162.579h0c-4.653,0-8.719-2.766-9.081-6.178l-1.027-9.669h17.24l.789,9.669C172.181,159.813,168.634,162.579,163.981,162.579Z",
    transform: "translate(-136.633 -136.558)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27181",
    "data-name": "Path 27181",
    d: "M189.587,162.579h0c-4.653,0-8.651-2.766-8.929-6.178l-.789-9.669h17.239l.552,9.669C197.854,159.813,194.24,162.579,189.587,162.579Z",
    transform: "translate(-145.388 -136.558)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27182",
    "data-name": "Path 27182",
    d: "M215.192,162.579h0c-4.654,0-8.583-2.766-8.778-6.178l-.552-9.669H223.1l.314,9.669C223.527,159.813,219.845,162.579,215.192,162.579Z",
    transform: "translate(-154.143 -136.558)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27183",
    "data-name": "Path 27183",
    d: "M240.8,162.579h0c-4.653,0-8.515-2.766-8.626-6.178l-.314-9.669H249.1l.077,9.669C249.2,159.813,245.451,162.579,240.8,162.579Z",
    transform: "translate(-162.898 -136.558)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27184",
    "data-name": "Path 27184",
    d: "M266.4,162.579h0c-4.653,0-8.447-2.766-8.474-6.178l-.077-9.669h17.24l-.161,9.669C274.874,159.813,271.056,162.579,266.4,162.579Z",
    transform: "translate(-171.653 -136.558)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27185",
    "data-name": "Path 27185",
    d: "M291.926,162.579h0c-4.653,0-8.379-2.766-8.323-6.178l.161-9.669H301l-.4,9.669C300.466,159.813,296.579,162.579,291.926,162.579Z",
    transform: "translate(-180.326 -136.558)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27186",
    "data-name": "Path 27186",
    d: "M317.41,162.579h0c-4.653,0-8.311-2.766-8.171-6.178l.4-9.669h17.239l-.636,9.669C326.017,159.813,322.063,162.579,317.41,162.579Z",
    transform: "translate(-188.958 -136.558)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27187",
    "data-name": "Path 27187",
    d: "M342.891,162.579h0c-4.654,0-8.244-2.766-8.019-6.178l.636-9.669h17.24l-.873,9.669C351.566,159.813,347.544,162.579,342.891,162.579Z",
    transform: "translate(-197.59 -136.558)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27188",
    "data-name": "Path 27188",
    d: "M368.371,162.579h0c-4.653,0-8.175-2.766-7.867-6.178l.873-9.669h17.24l-1.111,9.669C377.115,159.813,373.025,162.579,368.371,162.579Z",
    transform: "translate(-206.22 -136.558)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27189",
    "data-name": "Path 27189",
    d: "M393.851,162.579h0c-4.653,0-8.107-2.766-7.715-6.178l1.111-9.669h17.24l-1.349,9.669C402.662,159.813,398.5,162.579,393.851,162.579Z",
    transform: "translate(-214.848 -136.558)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27190",
    "data-name": "Path 27190",
    d: "M145.251,132.037l-17.373,9.528c70.174,2.858,117.695,2.976,189.638,0l-18.124-10.174Z",
    transform: "translate(-127.878 -131.392)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14724",
    "data-name": "Group 14724",
    transform: "translate(17.31 0.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14723",
    "data-name": "Group 14723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14722",
    "data-name": "Group 14722",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17371",
    "data-name": "Rectangle 17371",
    width: 23.299,
    height: 10.856,
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27191",
    "data-name": "Path 27191",
    d: "M177.6,140.984V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27192",
    "data-name": "Path 27192",
    d: "M177.6,140.969V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27193",
    "data-name": "Path 27193",
    d: "M177.6,140.954V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27194",
    "data-name": "Path 27194",
    d: "M177.6,140.938V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27195",
    "data-name": "Path 27195",
    d: "M177.6,140.923V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27196",
    "data-name": "Path 27196",
    d: "M177.6,140.908V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27197",
    "data-name": "Path 27197",
    d: "M177.6,140.893V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27198",
    "data-name": "Path 27198",
    d: "M177.6,140.878V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27199",
    "data-name": "Path 27199",
    d: "M177.6,140.863V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27200",
    "data-name": "Path 27200",
    d: "M177.6,140.848V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27201",
    "data-name": "Path 27201",
    d: "M177.6,140.833V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27202",
    "data-name": "Path 27202",
    d: "M177.6,140.817V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27203",
    "data-name": "Path 27203",
    d: "M177.6,140.8v2.6H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27204",
    "data-name": "Path 27204",
    d: "M177.6,140.787V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27205",
    "data-name": "Path 27205",
    d: "M177.6,140.772V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27206",
    "data-name": "Path 27206",
    d: "M177.6,140.757V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27207",
    "data-name": "Path 27207",
    d: "M177.6,140.742V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27208",
    "data-name": "Path 27208",
    d: "M177.6,140.727V143.4H152.979V131.218H177.6Z",
    transform: "translate(-153.642 -131.881)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27209",
    "data-name": "Path 27209",
    d: "M177.843,140.5v2.689H154.061v.8a25.527,25.527,0,0,1-.373-4.518,26.076,26.076,0,0,1,1.643-8.89V131h22.512Z",
    transform: "translate(-153.881 -131.666)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27210",
    "data-name": "Path 27210",
    d: "M179.008,140.622v2.7h-21.5v.684a24.8,24.8,0,0,1-.361-4.385A25.294,25.294,0,0,1,158.741,131v.147h20.267Z",
    transform: "translate(-155.046 -131.806)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27211",
    "data-name": "Path 27211",
    d: "M180.173,138.731v2.719H160.956v.566a24.054,24.054,0,0,1-.351-4.252,24.529,24.529,0,0,1,1.546-8.367,28.183,28.183,0,0,1,1.835-3.971v3.842h16.187Z",
    transform: "translate(-156.211 -129.93)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27212",
    "data-name": "Path 27212",
    d: "M181.337,138.919v2.734H165.453v4.453a23.516,23.516,0,0,1,.107-16.229,27.241,27.241,0,0,1,1.777-3.848v3.441h14Z",
    transform: "translate(-157.375 -130.134)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27213",
    "data-name": "Path 27213",
    d: "M182.5,139.107v2.75H168.867v4.206a22.756,22.756,0,0,1,.1-15.706,26.414,26.414,0,0,1,1.72-3.724v3.041H182.5Z",
    transform: "translate(-158.54 -130.337)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27214",
    "data-name": "Path 27214",
    d: "M183.666,139.3v2.765H172.28v3.959a22,22,0,0,1,.1-15.183,25.525,25.525,0,0,1,1.663-3.6v2.64h9.624Z",
    transform: "translate(-159.704 -130.541)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27215",
    "data-name": "Path 27215",
    d: "M184.831,139.484v2.78h-9.138v3.712a21.242,21.242,0,0,1,.1-14.659,24.593,24.593,0,0,1,1.6-3.475v2.239h7.436Z",
    transform: "translate(-160.869 -130.744)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27216",
    "data-name": "Path 27216",
    d: "M186,139.672v2.8h-6.889v3.465A20.482,20.482,0,0,1,179.2,131.8a23.76,23.76,0,0,1,1.548-3.351v1.838H186Z",
    transform: "translate(-162.034 -130.948)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27217",
    "data-name": "Path 27217",
    d: "M187.161,138.292v2.81h-4.64v3.218a19.929,19.929,0,0,1-1.167-6.814,21.835,21.835,0,0,1,4.772-13.114v4.527h1.035Z",
    transform: "translate(-163.199 -129.582)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27218",
    "data-name": "Path 27218",
    d: "M188.325,138.541v2.825h-2.392v2.971a19.164,19.164,0,0,1-1.122-6.552,21,21,0,0,1,4.589-12.61l-1.076,4.008Z",
    transform: "translate(-164.363 -129.846)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27219",
    "data-name": "Path 27219",
    d: "M189.49,138.789v2.84h-.143v2.724a18.41,18.41,0,0,1-1.077-6.29,20.16,20.16,0,0,1,4.406-12.106l-3.185,3.488Z",
    transform: "translate(-165.528 -130.11)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27220",
    "data-name": "Path 27220",
    d: "M190.11,145.282v0Z",
    transform: "translate(-166.148 -136.618)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27221",
    "data-name": "Path 27221",
    d: "M190.11,145.26v0Z",
    transform: "translate(-166.148 -136.611)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27222",
    "data-name": "Path 27222",
    d: "M190.11,145.237v0Z",
    transform: "translate(-166.148 -136.603)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27223",
    "data-name": "Path 27223",
    d: "M190.11,145.214v0Z",
    transform: "translate(-166.148 -136.595)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27224",
    "data-name": "Path 27224",
    d: "M190.11,145.191v0Z",
    transform: "translate(-166.148 -136.587)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27225",
    "data-name": "Path 27225",
    d: "M190.11,145.168v0Z",
    transform: "translate(-166.148 -136.58)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27226",
    "data-name": "Path 27226",
    d: "M190.11,145.146v0Z",
    transform: "translate(-166.148 -136.572)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27227",
    "data-name": "Path 27227",
    d: "M190.11,145.123v0Z",
    transform: "translate(-166.148 -136.564)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27228",
    "data-name": "Path 27228",
    d: "M190.11,145.1v0Z",
    transform: "translate(-166.148 -136.557)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27229",
    "data-name": "Path 27229",
    d: "M190.11,145.077v0Z",
    transform: "translate(-166.148 -136.549)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27230",
    "data-name": "Path 27230",
    d: "M190.11,145.055v0Z",
    transform: "translate(-166.148 -136.542)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27231",
    "data-name": "Path 27231",
    d: "M190.11,145.032v0Z",
    transform: "translate(-166.148 -136.534)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27232",
    "data-name": "Path 27232",
    d: "M190.11,145.009v0Z",
    transform: "translate(-166.148 -136.526)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27233",
    "data-name": "Path 27233",
    d: "M190.11,144.986v0Z",
    transform: "translate(-166.148 -136.518)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27234",
    "data-name": "Path 27234",
    d: "M190.11,144.963v0Z",
    transform: "translate(-166.148 -136.51)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27235",
    "data-name": "Path 27235",
    d: "M190.11,144.941v0Z",
    transform: "translate(-166.148 -136.503)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27236",
    "data-name": "Path 27236",
    d: "M190.11,144.918v0Z",
    transform: "translate(-166.148 -136.495)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27237",
    "data-name": "Path 27237",
    d: "M190.11,144.9v0Z",
    transform: "translate(-166.148 -136.488)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27238",
    "data-name": "Path 27238",
    d: "M190.11,144.872v0Z",
    transform: "translate(-166.148 -136.48)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27239",
    "data-name": "Path 27239",
    d: "M190.11,144.85v0Z",
    transform: "translate(-166.148 -136.472)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27240",
    "data-name": "Path 27240",
    d: "M190.11,144.827v0Z",
    transform: "translate(-166.148 -136.465)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27241",
    "data-name": "Path 27241",
    d: "M190.11,144.8v0Z",
    transform: "translate(-166.148 -136.457)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27242",
    "data-name": "Path 27242",
    d: "M190.11,144.781v0Z",
    transform: "translate(-166.148 -136.449)",
    fill: "#fef4d9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14727",
    "data-name": "Group 14727",
    transform: "translate(51.816 0.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14726",
    "data-name": "Group 14726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14725",
    "data-name": "Group 14725",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17372",
    "data-name": "Rectangle 17372",
    width: 18.358,
    height: 11.746,
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27243",
    "data-name": "Path 27243",
    d: "M224.692,141.516v2.59H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27244",
    "data-name": "Path 27244",
    d: "M224.692,141.5v2.6H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27245",
    "data-name": "Path 27245",
    d: "M224.692,141.486v2.62H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27246",
    "data-name": "Path 27246",
    d: "M224.692,141.471v2.635H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27247",
    "data-name": "Path 27247",
    d: "M224.692,141.455v2.65H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27248",
    "data-name": "Path 27248",
    d: "M224.692,141.44v2.666H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27249",
    "data-name": "Path 27249",
    d: "M224.692,141.425v2.681H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27250",
    "data-name": "Path 27250",
    d: "M224.692,141.41v2.7H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27251",
    "data-name": "Path 27251",
    d: "M224.692,141.395v2.711H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27252",
    "data-name": "Path 27252",
    d: "M224.692,141.38v2.726H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27253",
    "data-name": "Path 27253",
    d: "M224.692,141.365v2.741H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27254",
    "data-name": "Path 27254",
    d: "M224.692,141.35v2.756H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27255",
    "data-name": "Path 27255",
    d: "M224.692,141.334v2.771H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27256",
    "data-name": "Path 27256",
    d: "M224.692,141.319v2.787H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27257",
    "data-name": "Path 27257",
    d: "M224.692,141.3v2.8H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27258",
    "data-name": "Path 27258",
    d: "M224.692,141.289v2.817H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27259",
    "data-name": "Path 27259",
    d: "M224.692,141.274v2.832H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27260",
    "data-name": "Path 27260",
    d: "M224.692,141.259v2.847H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27261",
    "data-name": "Path 27261",
    d: "M224.692,141.244v2.862H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27262",
    "data-name": "Path 27262",
    d: "M224.692,141.229v2.877H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27263",
    "data-name": "Path 27263",
    d: "M224.692,141.213v2.892H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27264",
    "data-name": "Path 27264",
    d: "M224.692,141.2v2.907H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27265",
    "data-name": "Path 27265",
    d: "M224.692,141.183v2.923H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27266",
    "data-name": "Path 27266",
    d: "M224.692,141.168v2.938H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27267",
    "data-name": "Path 27267",
    d: "M224.692,141.153v2.953H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27268",
    "data-name": "Path 27268",
    d: "M224.692,141.138v2.968H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27269",
    "data-name": "Path 27269",
    d: "M224.692,141.123v2.983H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27270",
    "data-name": "Path 27270",
    d: "M224.692,141.108v3H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27271",
    "data-name": "Path 27271",
    d: "M224.692,141.092v3.013H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27272",
    "data-name": "Path 27272",
    d: "M224.692,141.077v3.029H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27273",
    "data-name": "Path 27273",
    d: "M224.692,141.062v3.044H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27274",
    "data-name": "Path 27274",
    d: "M224.692,141.047v3.059H205.007V131.033h19.685Z",
    transform: "translate(-205.671 -131.696)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27275",
    "data-name": "Path 27275",
    d: "M223.71,140.675v3.074H204.025V140.07H202.09a16.817,16.817,0,0,1,3.675-10.1v.7H223.71Z",
    transform: "translate(-204.688 -131.339)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27276",
    "data-name": "Path 27276",
    d: "M224.876,140.924v3.089h-18.47v1.32a14.566,14.566,0,0,1-.854-4.985,15.974,15.974,0,0,1,3.491-9.593v.184h15.833Z",
    transform: "translate(-205.854 -131.603)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27277",
    "data-name": "Path 27277",
    d: "M226.041,139.166v3.1h-16.22v1.073a13.813,13.813,0,0,1-.808-4.722,15.129,15.129,0,0,1,3.307-9.087,23.848,23.848,0,0,1,3.836-3.951V129.2h9.885Z",
    transform: "translate(-207.02 -129.861)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27278",
    "data-name": "Path 27278",
    d: "M227.207,139.527v3.12H213.238v.826a13.036,13.036,0,0,1-.763-4.459,14.292,14.292,0,0,1,3.123-8.583,22.546,22.546,0,0,1,3.623-3.731v2.874h7.986Z",
    transform: "translate(-208.186 -130.237)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27279",
    "data-name": "Path 27279",
    d: "M228.373,139.888v3.134h-9.6v4.5a12.8,12.8,0,0,1,.107-16.193,21.221,21.221,0,0,1,3.409-3.512v2.135h6.088Z",
    transform: "translate(-209.351 -130.612)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27280",
    "data-name": "Path 27280",
    d: "M229.539,138.8v3.15h-7.486v4.005a12.612,12.612,0,0,1-2.656-7.608c.036-5.385,3.922-10.235,10.177-13.724l-.035,4.254Z",
    transform: "translate(-210.517 -129.536)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27281",
    "data-name": "Path 27281",
    d: "M230.7,139.253v3.165h-5.367v3.513a11.767,11.767,0,0,1-2.479-7.1c.033-5.026,3.66-9.553,9.5-12.808l-1.652,3.324Z",
    transform: "translate(-211.683 -130.008)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27282",
    "data-name": "Path 27282",
    d: "M231.87,139.71v3.18h-3.248v3.021a10.929,10.929,0,0,1-2.3-6.594c.031-4.667,3.4-8.87,8.82-11.893l-3.27,2.394Z",
    transform: "translate(-212.849 -130.481)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27283",
    "data-name": "Path 27283",
    d: "M233.036,141.329v3.2h-1.129v2.529a9.6,9.6,0,0,1,.08-12.145,15.921,15.921,0,0,1,2.557-2.634h-1.507Z",
    transform: "translate(-214.015 -132.114)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27284",
    "data-name": "Path 27284",
    d: "M234.2,142.915v3.211l.989,2.037a8.8,8.8,0,0,1,.074-11.133H234.2Z",
    transform: "translate(-215.18 -133.716)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27285",
    "data-name": "Path 27285",
    d: "M234.689,145.882v0Z",
    transform: "translate(-215.667 -136.697)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27286",
    "data-name": "Path 27286",
    d: "M234.689,145.859v0Z",
    transform: "translate(-215.667 -136.69)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27287",
    "data-name": "Path 27287",
    d: "M234.689,145.836v0Z",
    transform: "translate(-215.667 -136.682)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27288",
    "data-name": "Path 27288",
    d: "M234.689,145.813v0Z",
    transform: "translate(-215.667 -136.674)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27289",
    "data-name": "Path 27289",
    d: "M234.689,145.791v0Z",
    transform: "translate(-215.667 -136.667)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27290",
    "data-name": "Path 27290",
    d: "M234.689,145.768v0Z",
    transform: "translate(-215.667 -136.659)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27291",
    "data-name": "Path 27291",
    d: "M234.689,145.745v0Z",
    transform: "translate(-215.667 -136.651)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27292",
    "data-name": "Path 27292",
    d: "M234.689,145.722v0Z",
    transform: "translate(-215.667 -136.643)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27293",
    "data-name": "Path 27293",
    d: "M234.689,145.7v0Z",
    transform: "translate(-215.667 -136.636)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27294",
    "data-name": "Path 27294",
    d: "M234.689,145.676v0Z",
    transform: "translate(-215.667 -136.628)",
    fill: "#fef4d9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14730",
    "data-name": "Group 14730",
    transform: "translate(85.76 0.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14729",
    "data-name": "Group 14729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14728",
    "data-name": "Group 14728",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17373",
    "data-name": "Rectangle 17373",
    width: 17.518,
    height: 11.926,
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27295",
    "data-name": "Path 27295",
    d: "M275.034,141.686V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27296",
    "data-name": "Path 27296",
    d: "M275.034,141.671v2.63H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27297",
    "data-name": "Path 27297",
    d: "M275.034,141.655V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27298",
    "data-name": "Path 27298",
    d: "M275.034,141.64V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27299",
    "data-name": "Path 27299",
    d: "M275.034,141.624V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27300",
    "data-name": "Path 27300",
    d: "M275.034,141.609V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27301",
    "data-name": "Path 27301",
    d: "M275.034,141.593V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27302",
    "data-name": "Path 27302",
    d: "M275.034,141.578V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27303",
    "data-name": "Path 27303",
    d: "M275.034,141.562V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27304",
    "data-name": "Path 27304",
    d: "M275.034,141.547V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27305",
    "data-name": "Path 27305",
    d: "M275.034,141.531V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27306",
    "data-name": "Path 27306",
    d: "M275.034,141.516V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27307",
    "data-name": "Path 27307",
    d: "M275.034,141.5v2.8H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27308",
    "data-name": "Path 27308",
    d: "M275.034,141.485V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27309",
    "data-name": "Path 27309",
    d: "M275.034,141.469V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27310",
    "data-name": "Path 27310",
    d: "M275.034,141.454V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27311",
    "data-name": "Path 27311",
    d: "M275.034,141.438V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27312",
    "data-name": "Path 27312",
    d: "M275.034,141.423V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27313",
    "data-name": "Path 27313",
    d: "M275.034,141.407V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27314",
    "data-name": "Path 27314",
    d: "M275.034,141.392V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27315",
    "data-name": "Path 27315",
    d: "M275.034,141.376V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27316",
    "data-name": "Path 27316",
    d: "M275.034,141.361v2.94H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27317",
    "data-name": "Path 27317",
    d: "M275.034,141.345V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27318",
    "data-name": "Path 27318",
    d: "M275.034,141.33V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27319",
    "data-name": "Path 27319",
    d: "M275.034,141.314V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27320",
    "data-name": "Path 27320",
    d: "M275.034,141.3v3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27321",
    "data-name": "Path 27321",
    d: "M275.034,141.283V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27322",
    "data-name": "Path 27322",
    d: "M275.034,141.268V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27323",
    "data-name": "Path 27323",
    d: "M275.034,141.252V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27324",
    "data-name": "Path 27324",
    d: "M275.034,141.237V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27325",
    "data-name": "Path 27325",
    d: "M275.034,141.221V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27326",
    "data-name": "Path 27326",
    d: "M275.034,141.206v3.1H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27327",
    "data-name": "Path 27327",
    d: "M275.034,141.19v3.11H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27328",
    "data-name": "Path 27328",
    d: "M275.034,141.175V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27329",
    "data-name": "Path 27329",
    d: "M275.034,141.159V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27330",
    "data-name": "Path 27330",
    d: "M275.034,141.144V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27331",
    "data-name": "Path 27331",
    d: "M275.034,141.128V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27332",
    "data-name": "Path 27332",
    d: "M275.034,141.113V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27333",
    "data-name": "Path 27333",
    d: "M275.034,141.1v3.2H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27334",
    "data-name": "Path 27334",
    d: "M275.034,141.082V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27335",
    "data-name": "Path 27335",
    d: "M275.034,141.066V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27336",
    "data-name": "Path 27336",
    d: "M275.034,141.051v3.25H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27337",
    "data-name": "Path 27337",
    d: "M275.034,141.035V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27338",
    "data-name": "Path 27338",
    d: "M275.034,141.019V144.3H256.19V131.048h18.844Z",
    transform: "translate(-256.853 -131.711)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27339",
    "data-name": "Path 27339",
    d: "M273.413,140.58v3.3H254.569V132.825h-3.191a29.95,29.95,0,0,1,26.637.175h-4.6Z",
    transform: "translate(-255.232 -131.287)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27340",
    "data-name": "Path 27340",
    d: "M274.255,141.241v3.312H255.412v-10.1h-1.533a26.2,26.2,0,0,1,23.307.153h-2.931Z",
    transform: "translate(-256.075 -131.964)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27341",
    "data-name": "Path 27341",
    d: "M272.977,141.9v3.328h-8.819v4.579c-7.8-.051-14.1-3.675-14.074-8.093s6.377-7.959,14.179-7.907a20.67,20.67,0,0,1,9.974,2.409h-1.26Z",
    transform: "translate(-254.797 -132.641)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1189",
    "data-name": "Ellipse 1189",
    cx: 6.667,
    cy: 11.772,
    rx: 6.667,
    ry: 11.772,
    transform: "translate(-2.401 15.758) rotate(-89.622)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27342",
    "data-name": "Path 27342",
    d: "M276.02,143.227c-.019,2.945-4.252,5.306-9.453,5.271s-9.4-2.45-9.382-5.4,4.252-5.306,9.453-5.271S276.039,140.281,276.02,143.227Z",
    transform: "translate(-257.188 -133.995)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1190",
    "data-name": "Ellipse 1190",
    cx: 4,
    cy: 7.063,
    rx: 4,
    ry: 7.063,
    transform: "translate(2.325 13.123) rotate(-89.623)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27343",
    "data-name": "Path 27343",
    d: "M273.7,144.55c-.01,1.473-2.126,2.653-4.726,2.636s-4.7-1.225-4.691-2.7,2.125-2.653,4.726-2.636S273.712,143.077,273.7,144.55Z",
    transform: "translate(-259.579 -135.35)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27344",
    "data-name": "Path 27344",
    d: "M272.544,145.211c0,.737-1.063,1.326-2.363,1.318s-2.35-.612-2.346-1.348,1.063-1.326,2.363-1.318S272.548,144.475,272.544,145.211Z",
    transform: "translate(-260.775 -136.027)",
    fill: "#fef4d9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14733",
    "data-name": "Group 14733",
    transform: "translate(116.477 0.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14732",
    "data-name": "Group 14732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14731",
    "data-name": "Group 14731",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17374",
    "data-name": "Rectangle 17374",
    width: 21.46,
    height: 12.012,
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27345",
    "data-name": "Path 27345",
    d: "M325.293,141.409v2.578H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27346",
    "data-name": "Path 27346",
    d: "M325.293,141.394v2.594H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27347",
    "data-name": "Path 27347",
    d: "M325.293,141.379v2.609H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27348",
    "data-name": "Path 27348",
    d: "M325.293,141.364v2.624H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27349",
    "data-name": "Path 27349",
    d: "M325.293,141.349v2.639H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27350",
    "data-name": "Path 27350",
    d: "M325.293,141.333v2.654H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27351",
    "data-name": "Path 27351",
    d: "M325.293,141.318v2.669H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27352",
    "data-name": "Path 27352",
    d: "M325.293,141.3v2.685H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27353",
    "data-name": "Path 27353",
    d: "M325.293,141.288v2.7H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27354",
    "data-name": "Path 27354",
    d: "M325.293,141.273v2.715H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27355",
    "data-name": "Path 27355",
    d: "M325.293,141.258v2.73H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27356",
    "data-name": "Path 27356",
    d: "M325.293,141.242v2.745H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27357",
    "data-name": "Path 27357",
    d: "M325.293,141.227v2.76H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27358",
    "data-name": "Path 27358",
    d: "M325.293,141.212v2.776H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27359",
    "data-name": "Path 27359",
    d: "M325.293,141.2v2.791H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27360",
    "data-name": "Path 27360",
    d: "M325.293,141.182v2.806H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27361",
    "data-name": "Path 27361",
    d: "M325.293,141.167v2.821H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27362",
    "data-name": "Path 27362",
    d: "M325.293,141.151v2.836H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27363",
    "data-name": "Path 27363",
    d: "M325.293,141.136v2.851H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27364",
    "data-name": "Path 27364",
    d: "M325.293,141.121v2.867H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27365",
    "data-name": "Path 27365",
    d: "M325.293,141.106v2.882H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27366",
    "data-name": "Path 27366",
    d: "M325.293,141.091v2.9H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27367",
    "data-name": "Path 27367",
    d: "M325.293,141.076v2.912H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27368",
    "data-name": "Path 27368",
    d: "M325.293,141.06v2.927H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27369",
    "data-name": "Path 27369",
    d: "M325.293,141.045v2.942H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27370",
    "data-name": "Path 27370",
    d: "M325.293,141.03v2.958H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27371",
    "data-name": "Path 27371",
    d: "M325.293,141.015v2.973H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27372",
    "data-name": "Path 27372",
    d: "M325.293,141v2.988H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27373",
    "data-name": "Path 27373",
    d: "M325.293,140.985v3H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27374",
    "data-name": "Path 27374",
    d: "M325.293,140.969v3.018H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27375",
    "data-name": "Path 27375",
    d: "M325.293,140.954v3.033H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27376",
    "data-name": "Path 27376",
    d: "M325.293,140.939v3.049H302.507V130.649h22.786Z",
    transform: "translate(-303.17 -131.312)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27377",
    "data-name": "Path 27377",
    d: "M325.292,138.712v3.064H302.506V128.437h17.722v-4.356a26.559,26.559,0,0,1,4.216,4.457A16.86,16.86,0,0,1,328,138.712Z",
    transform: "translate(-303.17 -129.1)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27378",
    "data-name": "Path 27378",
    d: "M325.694,139.06a14.617,14.617,0,0,1-.922,4.987V142.14H302.506V128.8h15.809v-3.64a25.285,25.285,0,0,1,4.005,4.235A16.019,16.019,0,0,1,325.694,139.06Z",
    transform: "translate(-303.17 -129.464)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27379",
    "data-name": "Path 27379",
    d: "M323.392,139.409a13.86,13.86,0,0,1-.873,4.724V142.5H302.506V129.164H316.4v-2.923a23.96,23.96,0,0,1,3.794,4.012A15.174,15.174,0,0,1,323.392,139.409Z",
    transform: "translate(-303.17 -129.828)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27380",
    "data-name": "Path 27380",
    d: "M321.089,139.757a13.084,13.084,0,0,1-.824,4.462v-1.352H302.506V129.528h11.981v-2.207a22.593,22.593,0,0,1,3.584,3.789A14.333,14.333,0,0,1,321.089,139.757Z",
    transform: "translate(-303.17 -130.191)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27381",
    "data-name": "Path 27381",
    d: "M318.787,138.523a12.314,12.314,0,0,1-.776,4.2v-1.074H302.506V128.309h5.59V123.7C314.737,127.521,318.825,132.763,318.787,138.523Z",
    transform: "translate(-303.17 -128.972)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27382",
    "data-name": "Path 27382",
    d: "M316.485,138.971a12.647,12.647,0,0,1-2.764,7.594v-4.455H302.506V128.772h3.956v-3.7C312.687,128.656,316.521,133.571,316.485,138.971Z",
    transform: "translate(-303.17 -129.435)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27383",
    "data-name": "Path 27383",
    d: "M314.183,139.419a11.8,11.8,0,0,1-2.58,7.088v-3.933h-9.1V129.235h2.322V126.45C310.639,129.791,314.216,134.379,314.183,139.419Z",
    transform: "translate(-303.17 -129.898)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27384",
    "data-name": "Path 27384",
    d: "M311.881,139.866a10.965,10.965,0,0,1-2.4,6.582v-3.411h-6.98V129.7h.688v-1.874C308.59,130.926,311.911,135.186,311.881,139.866Z",
    transform: "translate(-303.17 -130.361)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27385",
    "data-name": "Path 27385",
    d: "M309.1,140.314a10.114,10.114,0,0,1-2.211,6.076V143.5h-4.861V130.16l-.946-.962C306.061,132.062,309.127,135.994,309.1,140.314Z",
    transform: "translate(-302.689 -130.823)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27386",
    "data-name": "Path 27386",
    d: "M305.966,140.761a9.279,9.279,0,0,1-2.027,5.57v-2.369H301.2V130.623l-2.58-.052C303.181,133.2,305.992,136.8,305.966,140.761Z",
    transform: "translate(-301.859 -131.286)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27387",
    "data-name": "Path 27387",
    d: "M302.835,141.209a8.431,8.431,0,0,1-1.842,5.063v-1.847h-.626V131.945h-4.213C300.3,134.332,302.859,137.609,302.835,141.209Z",
    transform: "translate(-301.03 -131.749)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27388",
    "data-name": "Path 27388",
    d: "M301.915,143.565a7.587,7.587,0,0,1-1.659,4.557l1.492-1.326v-7.809h-1.432A7.588,7.588,0,0,1,301.915,143.565Z",
    transform: "translate(-302.412 -134.12)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27389",
    "data-name": "Path 27389",
    d: "M302.506,145.868v0Z",
    transform: "translate(-303.17 -136.438)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27390",
    "data-name": "Path 27390",
    d: "M302.506,145.845v0Z",
    transform: "translate(-303.17 -136.43)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27391",
    "data-name": "Path 27391",
    d: "M302.506,145.822v0Z",
    transform: "translate(-303.17 -136.422)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27392",
    "data-name": "Path 27392",
    d: "M302.506,145.8v0Z",
    transform: "translate(-303.17 -136.415)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27393",
    "data-name": "Path 27393",
    d: "M302.506,145.776v0Z",
    transform: "translate(-303.17 -136.407)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27394",
    "data-name": "Path 27394",
    d: "M302.506,145.753v0Z",
    transform: "translate(-303.17 -136.399)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27395",
    "data-name": "Path 27395",
    d: "M302.506,145.73v0Z",
    transform: "translate(-303.17 -136.391)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27396",
    "data-name": "Path 27396",
    d: "M302.506,145.707v0Z",
    transform: "translate(-303.17 -136.384)",
    fill: "#fef4d9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14736",
    "data-name": "Group 14736",
    transform: "translate(148.321 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14735",
    "data-name": "Group 14735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14734",
    "data-name": "Group 14734",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17375",
    "data-name": "Rectangle 17375",
    width: 24,
    height: 11.415,
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27397",
    "data-name": "Path 27397",
    d: "M375.848,140.729v2.4H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27398",
    "data-name": "Path 27398",
    d: "M375.848,140.714v2.419H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27399",
    "data-name": "Path 27399",
    d: "M375.848,140.7v2.434H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27400",
    "data-name": "Path 27400",
    d: "M375.848,140.684v2.45H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27401",
    "data-name": "Path 27401",
    d: "M375.848,140.669v2.465H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27402",
    "data-name": "Path 27402",
    d: "M375.848,140.654v2.48H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27403",
    "data-name": "Path 27403",
    d: "M375.848,140.639v2.495H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27404",
    "data-name": "Path 27404",
    d: "M375.848,140.624v2.51H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27405",
    "data-name": "Path 27405",
    d: "M375.848,140.608v2.525H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27406",
    "data-name": "Path 27406",
    d: "M375.848,140.593v2.54H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27407",
    "data-name": "Path 27407",
    d: "M375.848,140.578v2.555H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27408",
    "data-name": "Path 27408",
    d: "M375.848,140.563v2.57H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27409",
    "data-name": "Path 27409",
    d: "M375.848,140.548v2.586H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27410",
    "data-name": "Path 27410",
    d: "M375.848,140.533v2.6H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27411",
    "data-name": "Path 27411",
    d: "M375.848,140.518v2.616H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27412",
    "data-name": "Path 27412",
    d: "M375.848,140.5v2.631H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27413",
    "data-name": "Path 27413",
    d: "M375.848,140.488v2.646H350.521V130.392h25.326Z",
    transform: "translate(-351.184 -131.056)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27414",
    "data-name": "Path 27414",
    d: "M375.847,138.717v2.661H350.521V128.637h24.493V125.18a30.731,30.731,0,0,1,1.948,4.368h-1.115Z",
    transform: "translate(-351.184 -129.3)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27415",
    "data-name": "Path 27415",
    d: "M376.24,138.891a25.513,25.513,0,0,1-.432,4.51v-1.834H350.521V128.826h22.3v-3.085a29.844,29.844,0,0,1,1.893,4.243A26.058,26.058,0,0,1,376.24,138.891Z",
    transform: "translate(-351.184 -129.489)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27416",
    "data-name": "Path 27416",
    d: "M373.947,139.064a24.847,24.847,0,0,1-.419,4.378v-1.687H350.521V129.014H370.63V126.3a28.968,28.968,0,0,1,1.837,4.118A25.287,25.287,0,0,1,373.947,139.064Z",
    transform: "translate(-351.184 -129.678)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27417",
    "data-name": "Path 27417",
    d: "M371.655,139.238a23.989,23.989,0,0,1-.406,4.246v-1.539H350.521V129.2h17.917v-2.341a28.093,28.093,0,0,1,1.781,3.993A24.507,24.507,0,0,1,371.655,139.238Z",
    transform: "translate(-351.184 -129.867)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27418",
    "data-name": "Path 27418",
    d: "M369.363,139.412a23.317,23.317,0,0,1-.394,4.112v-1.391H350.521V129.392h15.725v-1.97a27.281,27.281,0,0,1,1.726,3.868A23.761,23.761,0,0,1,369.363,139.412Z",
    transform: "translate(-351.184 -130.055)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27419",
    "data-name": "Path 27419",
    d: "M367.07,139.585a22.509,22.509,0,0,1-.381,3.98v-1.243H350.521V129.58h13.533v-1.6a26.373,26.373,0,0,1,1.67,3.744A22.985,22.985,0,0,1,367.07,139.585Z",
    transform: "translate(-351.184 -130.244)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27420",
    "data-name": "Path 27420",
    d: "M364.777,139.759a21.756,21.756,0,0,1-.369,3.847v-1.1H350.521V129.769h11.341v-1.226a25.526,25.526,0,0,1,1.614,3.619A22.22,22.22,0,0,1,364.777,139.759Z",
    transform: "translate(-351.184 -130.433)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27421",
    "data-name": "Path 27421",
    d: "M362.485,138.229a21.451,21.451,0,0,1-1.353,7.318V141H350.521V128.255h7.013v-4.209A23.509,23.509,0,0,1,362.485,138.229Z",
    transform: "translate(-351.184 -128.918)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27422",
    "data-name": "Path 27422",
    d: "M360.193,138.464a20.7,20.7,0,0,1-1.3,7.056v-4.274h-8.368V128.5h4.9v-3.717A22.667,22.667,0,0,1,360.193,138.464Z",
    transform: "translate(-351.184 -129.168)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27423",
    "data-name": "Path 27423",
    d: "M357.9,138.7a19.926,19.926,0,0,1-1.255,6.8v-4h-6.123V128.754H353.3v-3.226A21.828,21.828,0,0,1,357.9,138.7Z",
    transform: "translate(-351.184 -129.417)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27424",
    "data-name": "Path 27424",
    d: "M355.607,138.933a19.16,19.16,0,0,1-1.207,6.534v-3.722h-3.879V129h.666v-2.734A20.988,20.988,0,0,1,355.607,138.933Z",
    transform: "translate(-351.184 -129.667)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27425",
    "data-name": "Path 27425",
    d: "M352.579,139.167a18.4,18.4,0,0,1-1.159,6.273v-3.445h-1.635V129.253l-1.45-2.243A20.151,20.151,0,0,1,352.579,139.167Z",
    transform: "translate(-350.448 -129.916)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27426",
    "data-name": "Path 27426",
    d: "M349.212,139.4a17.624,17.624,0,0,1-1.111,6.011l.609-3.169V129.5l-3.565-1.751A19.311,19.311,0,0,1,349.212,139.4Z",
    transform: "translate(-349.374 -130.166)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27427",
    "data-name": "Path 27427",
    d: "M350.521,145.3v0Z",
    transform: "translate(-351.184 -136.075)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27428",
    "data-name": "Path 27428",
    d: "M350.521,145.273v0Z",
    transform: "translate(-351.184 -136.067)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27429",
    "data-name": "Path 27429",
    d: "M350.521,145.25v0Z",
    transform: "translate(-351.184 -136.06)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27430",
    "data-name": "Path 27430",
    d: "M350.521,145.227v0Z",
    transform: "translate(-351.184 -136.052)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27431",
    "data-name": "Path 27431",
    d: "M350.521,145.2v0Z",
    transform: "translate(-351.184 -136.044)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27432",
    "data-name": "Path 27432",
    d: "M350.521,145.182v0Z",
    transform: "translate(-351.184 -136.037)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27433",
    "data-name": "Path 27433",
    d: "M350.521,145.159v0Z",
    transform: "translate(-351.184 -136.029)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27434",
    "data-name": "Path 27434",
    d: "M350.521,145.136v0Z",
    transform: "translate(-351.184 -136.021)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27435",
    "data-name": "Path 27435",
    d: "M350.521,145.113v0Z",
    transform: "translate(-351.184 -136.014)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27436",
    "data-name": "Path 27436",
    d: "M350.521,145.091v0Z",
    transform: "translate(-351.184 -136.006)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27437",
    "data-name": "Path 27437",
    d: "M350.521,145.068v0Z",
    transform: "translate(-351.184 -135.998)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27438",
    "data-name": "Path 27438",
    d: "M350.521,145.045v0Z",
    transform: "translate(-351.184 -135.991)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27439",
    "data-name": "Path 27439",
    d: "M350.521,145.022v0Z",
    transform: "translate(-351.184 -135.983)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27440",
    "data-name": "Path 27440",
    d: "M350.521,145v0Z",
    transform: "translate(-351.184 -135.975)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27441",
    "data-name": "Path 27441",
    d: "M350.521,144.977v0Z",
    transform: "translate(-351.184 -135.968)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27442",
    "data-name": "Path 27442",
    d: "M350.521,144.954v0Z",
    transform: "translate(-351.184 -135.96)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27443",
    "data-name": "Path 27443",
    d: "M350.521,144.931v0Z",
    transform: "translate(-351.184 -135.952)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27444",
    "data-name": "Path 27444",
    d: "M350.521,144.908v0Z",
    transform: "translate(-351.184 -135.945)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27445",
    "data-name": "Path 27445",
    d: "M350.521,144.886v0Z",
    transform: "translate(-351.184 -135.937)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27446",
    "data-name": "Path 27446",
    d: "M350.521,144.863v0Z",
    transform: "translate(-351.184 -135.929)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27447",
    "data-name": "Path 27447",
    d: "M350.521,144.84v0Z",
    transform: "translate(-351.184 -135.922)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27448",
    "data-name": "Path 27448",
    d: "M350.521,144.817v0Z",
    transform: "translate(-351.184 -135.914)",
    fill: "#fef4d9"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16623",
    "data-name": "Group 16623",
    transform: "matrix(0.993, 0.122, -0.122, 0.993, 53.384, 85.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26610",
    "data-name": "Path 26610",
    d: "M0,2.029,25.468,0l9.516,3.288L12.244,7.626Z",
    transform: "translate(0 0)",
    fill: "#f6e2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26611",
    "data-name": "Path 26611",
    d: "M12.594,3.428,0,0V20.97L12.594,24.7Z",
    transform: "translate(0 2.031)",
    fill: "#d2a96f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26612",
    "data-name": "Path 26612",
    d: "M0,2.169v21.27L22.39,21.06V0Z",
    transform: "translate(12.593 3.291)",
    fill: "#e7c798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27459",
    "data-name": "Path 27459",
    d: "M12.883,6.6l-.538-2.66L8.3,4.484,7.729,0,3.546.617,4.62,4.977,0,5.6l.841,3.74L5.436,8.292l1.237,5.024,2.664-.6-.652-5.16Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 18.223, 8.387)",
    fill: "#4b4495"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(23.845 11.809) rotate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, -23.6, -14.34)",
    filter: "url(#Path_33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M2.776,2.24a5.079,5.079,0,0,0-.911-.28,2.568,2.568,0,0,1-.75-.258.442.442,0,0,1-.221-.4A.554.554,0,0,1,1.144.822,1.168,1.168,0,0,1,1.821.649a1.7,1.7,0,0,1,.6.091,2.124,2.124,0,0,1,.5.28.954.954,0,0,0,.142.069.347.347,0,0,0,.117.019.233.233,0,0,0,.186-.1.357.357,0,0,0,.079-.23A.36.36,0,0,0,3.406.614.483.483,0,0,0,3.29.479,2.2,2.2,0,0,0,1.821,0,2.182,2.182,0,0,0,.936.173,1.456,1.456,0,0,0,.321.655a1.175,1.175,0,0,0-.22.7,1.044,1.044,0,0,0,.176.624,1.275,1.275,0,0,0,.523.4,4.536,4.536,0,0,0,.9.277,3.047,3.047,0,0,1,.766.249.4.4,0,0,1,.23.369.526.526,0,0,1-.246.47,1.291,1.291,0,0,1-.706.161,2.289,2.289,0,0,1-.656-.088,1.878,1.878,0,0,1-.567-.284.515.515,0,0,0-.259-.088.234.234,0,0,0-.186.1.383.383,0,0,0,.066.533,2.01,2.01,0,0,0,.7.35,3.186,3.186,0,0,0,.917.129,2.3,2.3,0,0,0,.9-.167,1.417,1.417,0,0,0,.611-.466,1.145,1.145,0,0,0,.217-.69.947.947,0,0,0-.186-.6A1.35,1.35,0,0,0,2.776,2.24Z",
    transform: "translate(23.85 14.46) rotate(-1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, -23.6, -14.34)",
    filter: "url(#Path_34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M2.622.258A.407.407,0,0,0,2.449.066a.5.5,0,0,0-.5,0,.407.407,0,0,0-.173.192L.038,4A.39.39,0,0,0,0,4.159a.309.309,0,0,0,.12.246.4.4,0,0,0,.265.1.37.37,0,0,0,.2-.054.356.356,0,0,0,.139-.167L1.1,3.441H3.315l.378.844a.348.348,0,0,0,.328.221.4.4,0,0,0,.268-.1.313.313,0,0,0,.117-.246A.39.39,0,0,0,4.368,4ZM1.374,2.811,2.206.939l.832,1.872Z",
    transform: "translate(28.71 14.39) rotate(-1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, -23.6, -14.34)",
    filter: "url(#Path_35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M4.279.1A.444.444,0,0,0,4,0a.345.345,0,0,0-.334.214L2.212,3.435.762.214A.355.355,0,0,0,.62.054.387.387,0,0,0,.422,0,.464.464,0,0,0,.129.1.313.313,0,0,0,0,.359.4.4,0,0,0,.038.511L1.777,4.267a.415.415,0,0,0,.173.186.5.5,0,0,0,.5,0,.415.415,0,0,0,.174-.186L4.367.511A.406.406,0,0,0,4.4.353.311.311,0,0,0,4.279.1Z",
    transform: "translate(33.82 14.31) rotate(-1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, -23.6, -14.34)",
    filter: "url(#Path_36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M2.666.643A.427.427,0,0,0,2.949.558a.3.3,0,0,0,.1-.243.283.283,0,0,0-.1-.233A.439.439,0,0,0,2.666,0H.391A.394.394,0,0,0,.1.1.376.376,0,0,0,0,.385V4.059a.376.376,0,0,0,.1.284.394.394,0,0,0,.287.1H2.666a.439.439,0,0,0,.283-.082.283.283,0,0,0,.1-.233.3.3,0,0,0-.1-.243A.428.428,0,0,0,2.666,3.8H.794V2.5H2.54a.438.438,0,0,0,.284-.082.283.283,0,0,0,.1-.233.291.291,0,0,0-.1-.239.438.438,0,0,0-.284-.082H.794V.643Z",
    transform: "translate(39.73 14.24) rotate(-1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0.02, -0.02, 1, -23.6, -14.34)",
    filter: "url(#Path_37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M4.163,2.173l-.793.119a2.761,2.761,0,0,1,.046.515,1.873,1.873,0,0,1-.343,1.21,1.162,1.162,0,0,1-.955.422,1.169,1.169,0,0,1-.961-.422,1.874,1.874,0,0,1-.343-1.21A1.862,1.862,0,0,1,1.156,1.6a1.174,1.174,0,0,1,.961-.419A1.3,1.3,0,0,1,2.7,1.31l-.339.6.073-.008,1.611-.242L3.438,0l-.4.71A2.3,2.3,0,0,0,2.117.532,2.214,2.214,0,0,0,.989.809,1.836,1.836,0,0,0,.255,1.6,2.68,2.68,0,0,0,0,2.807a2.674,2.674,0,0,0,.258,1.21,1.853,1.853,0,0,0,.734.794,2.2,2.2,0,0,0,1.125.277,2.182,2.182,0,0,0,1.119-.277,1.855,1.855,0,0,0,.734-.794,2.674,2.674,0,0,0,.258-1.21A3.023,3.023,0,0,0,4.163,2.173Z",
    transform: "translate(44.19 13.57) rotate(-1)",
    fill: "#fff"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14205",
    "data-name": "Group 14205",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 112.32, 35.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14203",
    "data-name": "Group 14203",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14192",
    "data-name": "Group 14192",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, -0.26, 0.26, 0.97, -232.38, 19.66)",
    filter: "url(#Path_26289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26289-2",
    "data-name": "Path 26289",
    d: "M68.395,113.865l-53.86,5.566a3.1,3.1,0,0,1-3.387-2.753L.016,8.97A3.1,3.1,0,0,1,2.769,5.583L56.629.016a3.1,3.1,0,0,1,3.387,2.753L71.148,110.477A3.1,3.1,0,0,1,68.395,113.865Z",
    transform: "matrix(0.97, 0.26, -0.26, 0.97, 229.55, 41.16)",
    fill: "#48d1cc"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17136",
    "data-name": "Rectangle 17136",
    width: 52.932,
    height: 106.918,
    rx: 1,
    transform: "translate(3.672 9.022) rotate(-5.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17137",
    "data-name": "Rectangle 17137",
    width: 52.888,
    height: 26.537,
    rx: 1,
    transform: "translate(11.919 89.044) rotate(-5.9)",
    fill: "#fef4d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14190",
    "data-name": "Group 14190",
    transform: "translate(32.852 96.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26293",
    "data-name": "Path 26293",
    d: "M.6,3.746,26.345,1.085A.544.544,0,0,0,26.234,0L.488,2.664a.545.545,0,0,0-.485.6H0A.545.545,0,0,0,.6,3.746Z",
    transform: "translate(0 0)",
    fill: "#4b4495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26294",
    "data-name": "Path 26294",
    d: "M26.831.488a.545.545,0,0,0-.6-.485L.488,2.664A.544.544,0,0,0,.6,3.746L26.345,1.085A.546.546,0,0,0,26.831.488Z",
    transform: "translate(0.245 2.371)",
    fill: "#4b4495"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26295",
    "data-name": "Path 26295",
    d: "M3.12,1.406A1.327,1.327,0,0,0,3,.972,1.544,1.544,0,0,0,1.4.009,1.564,1.564,0,0,0,.027,1.277a1.7,1.7,0,0,0-.02.454c.088.855,1.845,2.6,1.845,2.6S3.208,2.267,3.12,1.406Zm-1.485.875a.73.73,0,0,1-.8-.651.767.767,0,0,1,.095-.448A.74.74,0,0,1,1.485.823.71.71,0,0,1,2.1,1.06a.728.728,0,0,1-.468,1.221Z",
    transform: "translate(22.922 98.86)",
    fill: "#4b4495"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14804",
    "data-name": "Group 14804",
    transform: "translate(17.6 25.79) rotate(-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26610-2",
    "data-name": "Path 26610",
    d: "M0,1.53,19.2,0l7.174,2.479L9.232,5.75Z",
    transform: "translate(0 0)",
    fill: "#f6e2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26611-2",
    "data-name": "Path 26611",
    d: "M9.5,2.585,0,0V15.81l9.5,2.812Z",
    transform: "translate(0 1.531)",
    fill: "#d2a96f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26612-2",
    "data-name": "Path 26612",
    d: "M0,1.635V17.672l16.881-1.794V0Z",
    transform: "translate(9.495 2.481)",
    fill: "#e7c798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27459-2",
    "data-name": "Path 27459",
    d: "M9.713,4.977,9.308,2.971l-3.053.409L5.828,0,2.674.465l.809,3.287L0,4.219l.634,2.82L4.1,6.252l.933,3.788L7.04,9.587,6.548,5.7Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 13.739, 6.324)",
    fill: "#4b4495"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20678",
    "data-name": "Group 20678",
    transform: "translate(20.753 97.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26300",
    "data-name": "Path 26300",
    d: "M5.731.58a4.125,4.125,0,0,0-.583-.31A3.974,3.974,0,0,0,3.342.016a3.729,3.729,0,0,0-3.165,2.6,3.494,3.494,0,0,0-.155,1.5,3.741,3.741,0,0,0,4.1,3.32,3.437,3.437,0,0,0,2.136-.99A3.614,3.614,0,0,0,7.439,3.337,3.694,3.694,0,0,0,5.731.58Zm.155,5.651a3.255,3.255,0,0,1-1.806.777A3.293,3.293,0,0,1,.469,4.075a3.146,3.146,0,0,1,.117-1.2A3.235,3.235,0,0,1,3.4.444,2.9,2.9,0,0,1,4.935.677a2.5,2.5,0,0,1,.641.33,3.29,3.29,0,0,1,.311,5.224Z",
    transform: "translate(0 0)",
    fill: "#4b4495"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14202",
    "data-name": "Group 14202",
    transform: "translate(15.072 61.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14194",
    "data-name": "Group 14194",
    transform: "translate(2.004 2.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38518",
    "data-name": "Path 38518",
    d: "M3.078-.542A3.986,3.986,0,0,1,6.871,2.964,3.753,3.753,0,0,1,3.323,6.483a3.776,3.776,0,0,1-3.494-3.6A3.4,3.4,0,0,1,3.078-.542Z",
    transform: "translate(0.402 4.162)",
    fill: "#e6f9f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14193",
    "data-name": "Group 14193",
    transform: "translate(0 3.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26300-2",
    "data-name": "Path 26300",
    d: "M5.731.58a4.125,4.125,0,0,0-.583-.31A3.974,3.974,0,0,0,3.342.016a3.729,3.729,0,0,0-3.165,2.6,3.494,3.494,0,0,0-.155,1.5,3.741,3.741,0,0,0,4.1,3.32,3.437,3.437,0,0,0,2.136-.99A3.614,3.614,0,0,0,7.439,3.337,3.694,3.694,0,0,0,5.731.58Zm.155,5.651a3.255,3.255,0,0,1-1.806.777A3.293,3.293,0,0,1,.469,4.075a3.146,3.146,0,0,1,.117-1.2A3.235,3.235,0,0,1,3.4.444,2.9,2.9,0,0,1,4.935.677a2.5,2.5,0,0,1,.641.33,3.29,3.29,0,0,1,.311,5.224Z",
    transform: "translate(0 0)",
    fill: "#4b4495"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26301",
    "data-name": "Path 26301",
    d: "M-.816,8.082l2.922,1.1L4.337,1.908,1.424,7.97Z",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 4.136, 0.179)",
    fill: "#48d1cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14199",
    "data-name": "Group 14199",
    transform: "translate(13.809 5.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26305",
    "data-name": "Path 26305",
    d: "M29.4,1.181.6,4.157a.535.535,0,0,1-.585-.475L0,3.565a.535.535,0,0,1,.476-.585L29.278,0a.535.535,0,0,1,.585.476L29.876.6A.535.535,0,0,1,29.4,1.181Z",
    transform: "translate(0 0)",
    fill: "#423d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26306",
    "data-name": "Path 26306",
    d: "M29.4,1.181.6,4.157a.535.535,0,0,1-.585-.476L0,3.564a.535.535,0,0,1,.476-.585L29.278,0a.535.535,0,0,1,.585.476L29.876.6A.535.535,0,0,1,29.4,1.181Z",
    transform: "translate(0.217 2.097)",
    fill: "#423d7e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38519",
    "data-name": "Path 38519",
    d: "M-.035.184,2.8,22.027",
    transform: "translate(21.303 75.281)",
    fill: "none",
    stroke: "#4b4495",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding2);
export default __webpack_public_path__ + "static/media/Onboarding- 2.af0f5a04e197a8e674169ba10c630d9e.svg";
export { ForwardRef as ReactComponent };